import api from "../services/api";

export default {
    namespaced: true,
    state: {
        loading: false,
        loadError: "",
        alerts: [],
        saving: false,
        saveError: ""
    },
  
    getters: {
  
    },
  
    mutations: {
        setAlerts(state, data) {
            state.alerts = data;
        },
        loading(state) {
            state.loading = true;
            state.loadError = "";
        },
        loadComplete(state) {
            state.loading = false;
        },
        loadError(state, err) {
            state.alerts = [];
            state.loadError = err;
        },
        saving(state) {
            state.saving = true;
            state.saveError = "";
        },
        saveComplete(state) {
            state.saving = false;
        },
        saveError(state, err) {
            state.saveError = err;
        }
    },
  
    actions: {
        clear(context){
            context.commit("setAlerts", []);
        },
        load(context, options) {
            context.commit("loading");

            api.fetchAlerts({
                success: function(response) {
                    context.commit("setAlerts", response.data);

                    if (options && options.success) {
                        options.success(response.data);
                    }
                },
                error: function(e) {
                    context.commit("loadError", api.parseHttpRequestError(e));

                    if (options && options.error) {
                        options.error(e);
                    }
                },
                finally: function() {
                    context.commit("loadComplete");

                    if (options && options.finally) {
                        options.finally();
                    }
                }
            });
        },
        save(context, options) {
            context.commit("saving");

            api.saveAlert(
                options.alert,
                {
                    success: function(response) {
                        // the response we get back from this function is the list of all alerts, refreshed
                        context.commit("setAlerts", response.data);

                        if (options && options.success) {
                            options.success(response);
                        }
                    },
                    error: function(e) {
                        context.commit("saveError", api.parseHttpRequestError(e));

                        if (options && options.error) {
                            options.error(e);
                        }
                    },
                    finally: function() {
                        context.commit("saveComplete");

                        if (options && options.finally) {
                            options.finally();
                        }
                    }
                }
            );
        },
    }
}